module.exports = __webpack_public_path__ + "static/RivieraNights-Bold-935c7293da5e96344263e8f29b131d2d.woff2";